// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Farro:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************* Global ***********************************************/
body {
  min-height: 100vh !important;
}

main {
  margin-bottom: 5%;
}

/******************************************* PageTest ***********************************************/
.test-page {
  /* box-sizing: border-box; */
  width: 200px;
  height: 200px;
  padding: 20px;
  border: 2px solid black;
}
/******************************************* FrameCard **********************************************/
.frane-card-box {
  width: 102%;
  height: 102%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border: none;
}

.navCard {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18vh;
  /*border: solid 2px rgb(38, 66, 132) !important;*/
  border: solid 2px rgb(0, 77, 99) !important;
  border-radius: 20px;
  box-shadow: 10px 5px 10px rgba(0, 0, 0, 0.5);
  /*color: rgb(38, 66, 132);*/
  color: rgb(0, 77, 99);
  transition: background-color 1s ease;
}

.navCard:hover {
  background: linear-gradient(to top, rgb(58, 187, 184), rgb(153, 215, 211));
  border: none !important;
}

.NavText {
  font-size: 16px;
}

.NavIcon {
  font-size: 35px;
  transform: scale(1.6);
}
/******************************************* Spinner ***********************************************/
.spinner-center {
  margin-top: 300px;
  align-self: "center";
  display: flex;
  justify-content: center;
  align-items: center;
}
/******************************************* CustomTable ********************************************/
.search-box-input {
  display: inline;
  width: auto;
}

.table-container {
  border: solid grey 1px;
  border-radius: 5px;
  margin-bottom: 10%;
  padding: 20px;
}

thead {
  --bs-table-bg: rgba(0, 0, 0, 0) !important;
  color: white;
  background-color: rgb(58, 187, 184);
}

th:first-child {
  border-radius: 5px 0 0 0;
}

th:last-child {
  border-radius: 0 5px 0 0;
}

.pagination .page-link {
  color: rgb(0, 163, 154) !important;
  background-color: transparent;
}

.pagination .page-item.active .page-link {
  background-color: rgb(0, 163, 154) !important;
  color: white !important;
  border-color: rgb(0, 163, 154);
}

.staffings-filter-inline {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}

.filter-container {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.btn-primary {
  background-color: rgb(0, 163, 154) !important;
  color:white !important;
  border-color: rgb(0, 163, 154) !important;
}

.btn-primary:hover {
  background-color: rgb(0, 138, 130) !important; 
  color: white !important; 
  border-color: rgb(0, 138, 130) !important; 
}

.btn-outline-primary {
  background-color:transparent !important;
  color:rgb(0, 163, 154)! important;
  border-color: rgb(0, 163, 154) !important;
}

.btn-outline-primary:hover{
  background-color: rgb(0, 163, 154) !important;
  color:white !important;
  border-color: rgb(0, 163, 154) !important;
}

.react-tabs__tab {
  background-color: rgb(102, 204, 197);
  color: white;
  border: solid 1px rgb(102, 204, 197);
  border-radius: 5px 5px 0 0;
}

.react-tabs__tab--selected {
  background-color: rgb(0, 163, 154);
  font-size: 17px;
}

.customeTableSelectedRow {
  --bs-table-bg: rgba(0, 0, 0, 0) !important;
  background: lightgrey !important;
}

.customeTableNormalRow {
  --bs-table-bg: rgba(0, 0, 0, 0) !important;
  background: white !important;
}
/******************************** PMProjectsDropdownList *****************************************/
.project-master-dropdown-button {
  width: 500px !important;
}
/***************************************** FrameModal ***********************************************/
/* .modal-title {
  color: #555 !important;
}
.modal-dialog .modal-content {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.Generate {
  color: #fff;
  background-color: #0595db;
  border-color: #0595db;
  transition: background-color 20s ease;
}
@media only screen and (max-width: 600px) {
  .Generate {
    margin-top: 10px;
    align-items: center;
  }
}
.Generate:hover {
  color: #fff;
  border-color: #0571a8;
  background-color: #0571a8;
}
.Cancel_btn {
  color: #0571a8;
  border-color: #0571a8;
  background-color: #fff;
}
.Cancel_btn:hover {
  color: #0571a8;
  background-color: #ddd;
  border-color: #ddd;
} */

/******************************************* Fees Summary ***********************************************/
.feesSummary,
.breakDown {
  border-radius: 5px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid grey;
  overflow: hidden;
}
.feesSummary td,
.feesSummary th {
  border: none;
  color: rgb(85, 85, 85);
  line-height: 2;
}
.feesSummary th {
  padding-left: 10px;
  background-color: rgb(221, 221, 221);
}
.refreshTable {
  margin-left: 7%;
  margin-top: 20px;
  width: 70%;
}
.itemFeeSummary {
  border-bottom: 1px solid rgb(240, 240, 238);
}
.itemData {
  padding-left: 10px;
}
#breakDownTab {
  margin-left: 2%;
  width: 90%;
}
.breakDown,
.actualRecord,
.predictSpend,
.forecasteSpend,
.assumption,
.FeeSummaryComponent {
  margin-left: 5%;
  margin-right: 10%;
  width: 80%;
}
.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-right: 1%;
  margin-top: 4%;
  margin-bottom: 2%;
}
.pagination-bar button {
  border: none;
  background-color: white;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.collapseButton {
  border: none;
  background: rgb(221, 221, 221);
  float: right;
  margin-right: 1%;
}

/***************************************** HoursReport ***********************************************/
.hoursReport {
  border-radius: 5px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid grey;
  overflow: hidden;
}
.hoursReport td,
.hoursReport th {
  border: none;
  color: rgb(85, 85, 85);
  line-height: 2;
}
.hoursReport th {
  padding-left: 10px;
  background-color: rgb(221, 221, 221);
}

.hoursReportIntro {
  margin-top: 2%;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}

.hoursReportDate,
.startRow,
.endRow {
  margin-left: 3%;
}

.startDate,
.endDate {
  width: 90%;
}

.hoursReport .dateButton {
  height: 60%;
  border-radius: 5px;
  color: rgb(0, 163, 154);
  border: 1px solid grey;
}

.refreshButton,
.exportButton {
  margin-bottom: 2%;
  margin-left: 2%;
  border-radius: 5px;
  border: 1px solid grey;
}

.refreshButton {
  background-color: rgb(0, 163, 154) !important;
  color: white;
}

.exportButton {
  color: rgb(0, 163, 154);
}
.hourly-report-container {
  border-radius: 5px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid grey;
  overflow: hidden;
  padding: 30px;
}
.latest-report-container {
  border-radius: 5px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid grey;
  overflow: hidden;
  padding: 30px;
}

/***************************************** CustomTest ***********************************************/
.custom-test {
  margin-top: 50px;
  padding: 100px;
}
.title-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
.section-title {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 4px solid rgb(0, 163, 154);
  border-bottom: 4px solid rgb(0, 163, 154);
  border-radius: 8px;
  font-weight: bold;
  margin-bottom: 30px;
}
/***************************************** AvailableTableFilter ***********************************************/
.staffings-filter-inline {
  display: flex;
  align-items: center;
}
.staffings-filter-inline label {
  margin: 10px;
}
/***************************************** Navbar ***********************************************/

nav {
  height: 100%;
  padding: 0 !important;
}

.navbar-brand {
  margin-left: 1%;
}

.navbar {
  background-color: rgb(0, 163, 154) !important;
}

.navbar a {
  padding: 0.5rem 1rem;
}

.nav-link {
  display: flex;
  padding: 0.5rem 1.2rem !important;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
  transition: background-color 1s ease;
  font-family: "Farro", sans-serif;
  font-size: 16px !important;
}



.nav-link:hover {
  background-color: rgb(58, 187, 184);
  color: rgb(255, 255, 255);
  font-style: bold;
  font-size: 18px !important;
}

.greeting {
  font-size: 17px;
  font-family: "Farro", sans-serif;
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
}

/* Response Part for Nav Cards */
@media (min-width: 992px) {
  .nav-link {
    height: 70px;
    font-size: 17px;
  }
}

.nav-item.nav-link.active {
  color: rgb(38, 66, 132);
}
/***************************************** Footer ***********************************************/
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgb(0, 163, 154);
  color: rgb(255, 255, 255);
  /* padding-left: 5%; */
  display: flex;
  align-items: center;
  height: 60px;
  z-index: 1000;
}

/***************************************** NavePage ***********************************************/
.navTitle {
  color: rgb(38, 66, 132);
}
/***************************************** Tooltip ************************************************/
.custom-tooltip .tooltip-inner {
  max-width: 400px; 
  width: 400px; 
}

/***************************************** ICC Swtich ************************************************/
.nav-icc-switch{
  display: flex;
  padding: 0.5rem 1.2rem !important;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
  transition: background-color 1s ease;
  font-family: "Farro", sans-serif;
  font-size: 16px !important;
}

/* Styles for the switch input */
.custom-switch .form-check-input {
  width: 0;
  height: 0;
  opacity: 0;
}

/* Styles for the switch label */
.custom-switch .form-check-label {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 120px; /* Fixed width for the switch */
  height: 30px; /* Fixed height for the switch */
  padding-right: 30px; /* Add padding for the knob */
  background-color: #ccc; /* Background color when switch is off */
  border-radius: 20px; /* Adjust border radius as needed */
  cursor: pointer;
  transition: padding-right 0.3s; /* Smooth transition for text movement */
}

/* Styles for the switch label's pseudo-element (before) */
.custom-switch .form-check-label::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px; /* Position the knob on the left side initially */
  width: 26px; /* Width of the knob */
  height: 26px; /* Height of the knob */
  background-color: #fff; /* Color of the switch knob */
  border-radius: 50%; /* Makes the knob round */
  transition: 0.3s; /* Smooth transition when toggling */
}

/* Styles for the switch label's pseudo-element (after) */
.custom-switch .form-check-label::after {
  content: '';
  position: absolute;
  top: 6px;
  left: 6px; /* Position the switch on the left side initially */
  width: 18px; /* Width of the switch */
  height: 18px; /* Height of the switch */
  background-color: #666; /* Background color of the switch when it's on */
  border-radius: 50%; /* Makes the switch round */
  transition: 0.3s; /* Smooth transition when toggling */
}

/* Styles for the switch label when the input is checked */
.custom-switch .form-check-input:checked + .form-check-label {
  background-color: #66bb6a; /* Background color when switch is on */ 
  justify-content: flex-end; /* Center the text by pushing it to the right */
}

/* Styles for the switch label's pseudo-element (before) when the input is checked */
.custom-switch .form-check-input:checked + .form-check-label::before {
  transform: translateX(90px); /* Move the knob to the right */
}

/* Styles for the switch label's pseudo-element (after) when the input is checked */
.custom-switch .form-check-input:checked + .form-check-label::after {
  background-color: #fff; /* Change knob color when switch is on */
  transform: translateX(90px); /* Move the switch to the right */
}


/* Custom styles for the switch */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: background-color 0.4s, transform 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: transform 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: blue;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Text */
.slider::before {
  content: "MATER";
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transition: transform 0.4s;
}

input:checked + .slider::before {
  content: "ICC";
  color: white;
  transform: translateX(34px);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,mGAAmG;AACnG;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qGAAqG;AACrG;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;AACA,qGAAqG;AACrG;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iDAAiD;EACjD,2CAA2C;EAC3C,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,0EAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA,oGAAoG;AACpG;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,qGAAqG;AACrG;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;AACA,kGAAkG;AAClG;EACE,uBAAuB;AACzB;AACA,qGAAqG;AACrG;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG;;AAEH,yGAAyG;AACzG;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;;;;;;EAME,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sGAAsG;AACtG;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA,qGAAqG;AACrG;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,+GAA+G;AAC/G;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA,iGAAiG;;AAGjG;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;AAC5B;;;;AAIA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;AACzB;AACA,iGAAiG;AACjG;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA,mGAAmG;AACnG;EACE,uBAAuB;AACzB;AACA,mGAAmG;AACnG;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,sGAAsG;AACtG;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY,EAAE,+BAA+B;EAC7C,YAAY,EAAE,gCAAgC;EAC9C,mBAAmB,EAAE,6BAA6B;EAClD,sBAAsB,EAAE,wCAAwC;EAChE,mBAAmB,EAAE,mCAAmC;EACxD,eAAe;EACf,8BAA8B,EAAE,wCAAwC;AAC1E;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS,EAAE,iDAAiD;EAC5D,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,uBAAuB;EACrC,sBAAsB,EAAE,6BAA6B;EACrD,kBAAkB,EAAE,yBAAyB;EAC7C,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS,EAAE,mDAAmD;EAC9D,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,yBAAyB;EACvC,sBAAsB,EAAE,gDAAgD;EACxE,kBAAkB,EAAE,2BAA2B;EAC/C,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB,EAAE,uCAAuC;EAClE,yBAAyB,EAAE,+CAA+C;AAC5E;;AAEA,oFAAoF;AACpF;EACE,2BAA2B,EAAE,+BAA+B;AAC9D;;AAEA,mFAAmF;AACnF;EACE,sBAAsB,EAAE,wCAAwC;EAChE,2BAA2B,EAAE,iCAAiC;AAChE;;;AAGA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B","sourcesContent":["/******************************************* Global ***********************************************/\nbody {\n  min-height: 100vh !important;\n}\n\nmain {\n  margin-bottom: 5%;\n}\n\n/******************************************* PageTest ***********************************************/\n.test-page {\n  /* box-sizing: border-box; */\n  width: 200px;\n  height: 200px;\n  padding: 20px;\n  border: 2px solid black;\n}\n/******************************************* FrameCard **********************************************/\n.frane-card-box {\n  width: 102%;\n  height: 102%;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  border: none;\n}\n\n.navCard {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 18vh;\n  /*border: solid 2px rgb(38, 66, 132) !important;*/\n  border: solid 2px rgb(0, 77, 99) !important;\n  border-radius: 20px;\n  box-shadow: 10px 5px 10px rgba(0, 0, 0, 0.5);\n  /*color: rgb(38, 66, 132);*/\n  color: rgb(0, 77, 99);\n  transition: background-color 1s ease;\n}\n\n.navCard:hover {\n  background: linear-gradient(to top, rgb(58, 187, 184), rgb(153, 215, 211));\n  border: none !important;\n}\n\n.NavText {\n  font-size: 16px;\n}\n\n.NavIcon {\n  font-size: 35px;\n  transform: scale(1.6);\n}\n/******************************************* Spinner ***********************************************/\n.spinner-center {\n  margin-top: 300px;\n  align-self: \"center\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/******************************************* CustomTable ********************************************/\n.search-box-input {\n  display: inline;\n  width: auto;\n}\n\n.table-container {\n  border: solid grey 1px;\n  border-radius: 5px;\n  margin-bottom: 10%;\n  padding: 20px;\n}\n\nthead {\n  --bs-table-bg: rgba(0, 0, 0, 0) !important;\n  color: white;\n  background-color: rgb(58, 187, 184);\n}\n\nth:first-child {\n  border-radius: 5px 0 0 0;\n}\n\nth:last-child {\n  border-radius: 0 5px 0 0;\n}\n\n.pagination .page-link {\n  color: rgb(0, 163, 154) !important;\n  background-color: transparent;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: rgb(0, 163, 154) !important;\n  color: white !important;\n  border-color: rgb(0, 163, 154);\n}\n\n.staffings-filter-inline {\n  margin-top: 20px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.filter-container {\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n}\n\n.btn-primary {\n  background-color: rgb(0, 163, 154) !important;\n  color:white !important;\n  border-color: rgb(0, 163, 154) !important;\n}\n\n.btn-primary:hover {\n  background-color: rgb(0, 138, 130) !important; \n  color: white !important; \n  border-color: rgb(0, 138, 130) !important; \n}\n\n.btn-outline-primary {\n  background-color:transparent !important;\n  color:rgb(0, 163, 154)! important;\n  border-color: rgb(0, 163, 154) !important;\n}\n\n.btn-outline-primary:hover{\n  background-color: rgb(0, 163, 154) !important;\n  color:white !important;\n  border-color: rgb(0, 163, 154) !important;\n}\n\n.react-tabs__tab {\n  background-color: rgb(102, 204, 197);\n  color: white;\n  border: solid 1px rgb(102, 204, 197);\n  border-radius: 5px 5px 0 0;\n}\n\n.react-tabs__tab--selected {\n  background-color: rgb(0, 163, 154);\n  font-size: 17px;\n}\n\n.customeTableSelectedRow {\n  --bs-table-bg: rgba(0, 0, 0, 0) !important;\n  background: lightgrey !important;\n}\n\n.customeTableNormalRow {\n  --bs-table-bg: rgba(0, 0, 0, 0) !important;\n  background: white !important;\n}\n/******************************** PMProjectsDropdownList *****************************************/\n.project-master-dropdown-button {\n  width: 500px !important;\n}\n/***************************************** FrameModal ***********************************************/\n/* .modal-title {\n  color: #555 !important;\n}\n.modal-dialog .modal-content {\n  border: 1px solid #d7d7d7;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n.Generate {\n  color: #fff;\n  background-color: #0595db;\n  border-color: #0595db;\n  transition: background-color 20s ease;\n}\n@media only screen and (max-width: 600px) {\n  .Generate {\n    margin-top: 10px;\n    align-items: center;\n  }\n}\n.Generate:hover {\n  color: #fff;\n  border-color: #0571a8;\n  background-color: #0571a8;\n}\n.Cancel_btn {\n  color: #0571a8;\n  border-color: #0571a8;\n  background-color: #fff;\n}\n.Cancel_btn:hover {\n  color: #0571a8;\n  background-color: #ddd;\n  border-color: #ddd;\n} */\n\n/******************************************* Fees Summary ***********************************************/\n.feesSummary,\n.breakDown {\n  border-radius: 5px;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid grey;\n  overflow: hidden;\n}\n.feesSummary td,\n.feesSummary th {\n  border: none;\n  color: rgb(85, 85, 85);\n  line-height: 2;\n}\n.feesSummary th {\n  padding-left: 10px;\n  background-color: rgb(221, 221, 221);\n}\n.refreshTable {\n  margin-left: 7%;\n  margin-top: 20px;\n  width: 70%;\n}\n.itemFeeSummary {\n  border-bottom: 1px solid rgb(240, 240, 238);\n}\n.itemData {\n  padding-left: 10px;\n}\n#breakDownTab {\n  margin-left: 2%;\n  width: 90%;\n}\n.breakDown,\n.actualRecord,\n.predictSpend,\n.forecasteSpend,\n.assumption,\n.FeeSummaryComponent {\n  margin-left: 5%;\n  margin-right: 10%;\n  width: 80%;\n}\n.pagination-bar {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 1%;\n  margin-top: 4%;\n  margin-bottom: 2%;\n}\n.pagination-bar button {\n  border: none;\n  background-color: white;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n.collapseButton {\n  border: none;\n  background: rgb(221, 221, 221);\n  float: right;\n  margin-right: 1%;\n}\n\n/***************************************** HoursReport ***********************************************/\n.hoursReport {\n  border-radius: 5px;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid grey;\n  overflow: hidden;\n}\n.hoursReport td,\n.hoursReport th {\n  border: none;\n  color: rgb(85, 85, 85);\n  line-height: 2;\n}\n.hoursReport th {\n  padding-left: 10px;\n  background-color: rgb(221, 221, 221);\n}\n\n.hoursReportIntro {\n  margin-top: 2%;\n  margin-left: 5%;\n  margin-right: 5%;\n  width: 90%;\n}\n\n.hoursReportDate,\n.startRow,\n.endRow {\n  margin-left: 3%;\n}\n\n.startDate,\n.endDate {\n  width: 90%;\n}\n\n.hoursReport .dateButton {\n  height: 60%;\n  border-radius: 5px;\n  color: rgb(0, 163, 154);\n  border: 1px solid grey;\n}\n\n.refreshButton,\n.exportButton {\n  margin-bottom: 2%;\n  margin-left: 2%;\n  border-radius: 5px;\n  border: 1px solid grey;\n}\n\n.refreshButton {\n  background-color: rgb(0, 163, 154) !important;\n  color: white;\n}\n\n.exportButton {\n  color: rgb(0, 163, 154);\n}\n.hourly-report-container {\n  border-radius: 5px;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid grey;\n  overflow: hidden;\n  padding: 30px;\n}\n.latest-report-container {\n  border-radius: 5px;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 1px solid grey;\n  overflow: hidden;\n  padding: 30px;\n}\n\n/***************************************** CustomTest ***********************************************/\n.custom-test {\n  margin-top: 50px;\n  padding: 100px;\n}\n.title-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n.section-title {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-top: 4px solid rgb(0, 163, 154);\n  border-bottom: 4px solid rgb(0, 163, 154);\n  border-radius: 8px;\n  font-weight: bold;\n  margin-bottom: 30px;\n}\n/***************************************** AvailableTableFilter ***********************************************/\n.staffings-filter-inline {\n  display: flex;\n  align-items: center;\n}\n.staffings-filter-inline label {\n  margin: 10px;\n}\n/***************************************** Navbar ***********************************************/\n@import url(\"https://fonts.googleapis.com/css2?family=Farro:wght@700&display=swap\");\n\nnav {\n  height: 100%;\n  padding: 0 !important;\n}\n\n.navbar-brand {\n  margin-left: 1%;\n}\n\n.navbar {\n  background-color: rgb(0, 163, 154) !important;\n}\n\n.navbar a {\n  padding: 0.5rem 1rem;\n}\n\n.nav-link {\n  display: flex;\n  padding: 0.5rem 1.2rem !important;\n  align-items: center;\n  justify-content: center;\n  color: rgb(255, 255, 255);\n  transition: background-color 1s ease;\n  font-family: \"Farro\", sans-serif;\n  font-size: 16px !important;\n}\n\n\n\n.nav-link:hover {\n  background-color: rgb(58, 187, 184);\n  color: rgb(255, 255, 255);\n  font-style: bold;\n  font-size: 18px !important;\n}\n\n.greeting {\n  font-size: 17px;\n  font-family: \"Farro\", sans-serif;\n  color: rgb(255, 255, 255);\n  display: flex;\n  align-items: center;\n}\n\n/* Response Part for Nav Cards */\n@media (min-width: 992px) {\n  .nav-link {\n    height: 70px;\n    font-size: 17px;\n  }\n}\n\n.nav-item.nav-link.active {\n  color: rgb(38, 66, 132);\n}\n/***************************************** Footer ***********************************************/\nfooter {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: rgb(0, 163, 154);\n  color: rgb(255, 255, 255);\n  /* padding-left: 5%; */\n  display: flex;\n  align-items: center;\n  height: 60px;\n  z-index: 1000;\n}\n\n/***************************************** NavePage ***********************************************/\n.navTitle {\n  color: rgb(38, 66, 132);\n}\n/***************************************** Tooltip ************************************************/\n.custom-tooltip .tooltip-inner {\n  max-width: 400px; \n  width: 400px; \n}\n\n/***************************************** ICC Swtich ************************************************/\n.nav-icc-switch{\n  display: flex;\n  padding: 0.5rem 1.2rem !important;\n  align-items: center;\n  justify-content: center;\n  color: rgb(255, 255, 255);\n  transition: background-color 1s ease;\n  font-family: \"Farro\", sans-serif;\n  font-size: 16px !important;\n}\n\n/* Styles for the switch input */\n.custom-switch .form-check-input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n}\n\n/* Styles for the switch label */\n.custom-switch .form-check-label {\n  position: relative;\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 120px; /* Fixed width for the switch */\n  height: 30px; /* Fixed height for the switch */\n  padding-right: 30px; /* Add padding for the knob */\n  background-color: #ccc; /* Background color when switch is off */\n  border-radius: 20px; /* Adjust border radius as needed */\n  cursor: pointer;\n  transition: padding-right 0.3s; /* Smooth transition for text movement */\n}\n\n/* Styles for the switch label's pseudo-element (before) */\n.custom-switch .form-check-label::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px; /* Position the knob on the left side initially */\n  width: 26px; /* Width of the knob */\n  height: 26px; /* Height of the knob */\n  background-color: #fff; /* Color of the switch knob */\n  border-radius: 50%; /* Makes the knob round */\n  transition: 0.3s; /* Smooth transition when toggling */\n}\n\n/* Styles for the switch label's pseudo-element (after) */\n.custom-switch .form-check-label::after {\n  content: '';\n  position: absolute;\n  top: 6px;\n  left: 6px; /* Position the switch on the left side initially */\n  width: 18px; /* Width of the switch */\n  height: 18px; /* Height of the switch */\n  background-color: #666; /* Background color of the switch when it's on */\n  border-radius: 50%; /* Makes the switch round */\n  transition: 0.3s; /* Smooth transition when toggling */\n}\n\n/* Styles for the switch label when the input is checked */\n.custom-switch .form-check-input:checked + .form-check-label {\n  background-color: #66bb6a; /* Background color when switch is on */ \n  justify-content: flex-end; /* Center the text by pushing it to the right */\n}\n\n/* Styles for the switch label's pseudo-element (before) when the input is checked */\n.custom-switch .form-check-input:checked + .form-check-label::before {\n  transform: translateX(90px); /* Move the knob to the right */\n}\n\n/* Styles for the switch label's pseudo-element (after) when the input is checked */\n.custom-switch .form-check-input:checked + .form-check-label::after {\n  background-color: #fff; /* Change knob color when switch is on */\n  transform: translateX(90px); /* Move the switch to the right */\n}\n\n\n/* Custom styles for the switch */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n/* Hide default checkbox */\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* Slider */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: background-color 0.4s, transform 0.4s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: transform 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: blue;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n/* Text */\n.slider::before {\n  content: \"MATER\";\n  color: black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  transition: transform 0.4s;\n}\n\ninput:checked + .slider::before {\n  content: \"ICC\";\n  color: white;\n  transform: translateX(34px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
